import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { createTitle } from "@/functions/createTitle";
import { branches_helper } from "@/helpers/branches_helper";
import { pages_helper } from "@/helpers/pages_helper";
import sn from "@/snippets";

export default function BranchesPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const title = "Our Locations";
  const branches = branches_helper.fetch();
  const page = pages_helper.find("85b4866a-8de7-42c7-86da-599d02bd753f", "id");

  return {
    props: {
      meta: { title: createTitle(title) },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Contact us", href: getRoute("contact") },
              { label: title, href: getRoute("branches") },
            ],
          },
        },
        {
          component: "Header",
          props: {
            className: "bg-primary text-white",
            title: page.title ?? null,
            description: page.description ?? null,
            img: page.cover_image ?? null,
          },
        },

        { component: "LeadooForm" },
        { component: "BranchLocations", props: { branches } },
        // {
        //   component: "BranchLookupPanel",
        //   props: { branches: branches_helper.fetch() },
        // },
        sn.form({ page }),
      ],
    },
  };
}
